var SalesSDK = function (responseTimeoutMilliseconds) {
    var salesSdkVersion = '1.0.0';

    // timeout to wait response from eHopper
    var timeout = responseTimeoutMilliseconds;

    // array of deferred objects
    var sendsMessageDic = {};
    // array of timeout objects
    var timeoutObjs = {};

    // Type of product
    var ProductType = {
        Regular: 0,
        Variant: 1
    };

    var InventoryType = {
        Standard: 'Standard',
        Serialized: 'Serialized', // WARNING: WITHOUT SERIAL NUMBER FOR Serialized product
        NonInventory: 'NonInventory'
    };

    var ProductLineItem = function () {
        var self = this;
        // string Example: '038e1c2de69f4b34'
        self.productLineItemId = null;
        // string Example: '038e1c2de69f4b34'
        self.sku = null;
        // string Example: '2163'
        self.externalProductId = null;
        // string Example: '042100005264'
        self.upc = null;
        // string Example: '042100005264'
        self.productCode = 0;
        // array Example: [{serialNo: '123312'}]
        self.serialNumbers = new Array();
        // string Example: 'Mobile Share with unlimited text&talk ($0), DataPro 2Gb for Smartphone on 4G LTE with CCS ($40.00). Mobile # (404) 274 - 0001'
        self.itemDescription = null;
        // double Example: 33207.00
        self.unitPrice = null;
        // double Example: 20.00
        self.discount = null;
        // ?? Example: ?? USE ONLY TO THE '0.0.12' SDK VERSION
        self.modifierTransactionLineItems = null;
        // ?? Example: ?? USE ONLY TO THE '0.0.12' SDK VERSION
        self.variantKeys = null;
        // int Example: null
        self.cartBundleId = null;
        // int Example: null
        self.bundleId = null;
        // int Example: null
        self.quantity = null;
        // double Example: 0
        self.minPrice = 0;
        // bit Example: 1
        self.isReturnable = null;
        // bit Example: 1
        self.isVoidable = null;
        // bit Example: 1 USE ONLY FROM THE '0.0.13' SDK VERSION
        self.isDummySN = 0;
        // string Example: 'eComm','LenPro' etc. USE ONLY FROM THE '0.0.13' SDK VERSION
        self.paymentType = null;
        // double Example: 20.00 USE ONLY FROM THE '0.0.13' SDK VERSION
        self.paymentAmount = null;
        // bit Example: 1
        self.calculateAsProfit = null;
        // bit Example: 1
        self.isFinancing = null;
        //int Example: 1234
        self.financingProgramId = null;
        // bit Example: 0
        self.isQuantityReadonly = 0;
        // bit Example: 0
        self.isDiscountReadonly = 0;
        // bit Example: 0
        self.isSalePriceReadonly = 0;
        // string Example: '68330b1ed47313'
        self.appId = null;
        // string Example: null
        self.externalServiceInfo = null;
        // Total Quantity from cart
        self.totalQuantity = null;
        // bit Example: 0
        self.isActivationItem = 0;
        // string JSON Example: object
        self.activationInfo = null;
        // string JSON Example: object
        self.receiptData = null;
        // bit Example: 0
        self.isTaxReadonly = 0;
        // array Example: [ {"taxCode":"10", "taxShortName":"Sale Tax", "taxAmount": "7.00"}]
        self.taxList = [];
        // string Example: 'S'
        self.itemAction = null;
        // string Example: 2
        self.gradeCodeId = null;
        //string Example: 
        self.returnReasonCodeId = null;
        //string Example: 0 - False, 1 - True
        self.isReasonCodeReadonly = 0;
        //string Example: 0 - False, 1 - True
        self.isCouponAppliable = 0;
        // bit Example: 0 - False, 1 - True
        self.isPaymentProduct = 0;
        // bit Example: 0 - False, 1 - True
        self.isHiddenOnReceipt = 0;
        // bit Example: 0 - False, 1 - True
        self.isHiddenInCart = 0;
        // bit Example: 0 - False, 1 - True
        self.isIgnoreBundleOnReturn = 0;
        // bit Example: 0 - False, 1 - True
        self.isCellPhone = 0;
        //string Example: mandatory, optional, notRequired
        self.autopayEnrollment = null;
        //string Example: beforePayment, duringPayment, afterPayment
        self.tokenizationMode = null;

        this.__defineSetter__("serial", function (val) {
            var serials = new Array();
            if (serials && val) {
                val.split(',').forEach(function (item) {
                    serials.push({ serialNo: item });
                });

                self.serialNumbers = serials;
            }
        });
        this.__defineGetter__("serial", function () {
            if (!self.serialNumbers) {
                return null;
            }

            var serials = self.serialNumbers.map(function (item) {
                return item['serialNo'];
            });

            return serials.join(',');
        });
    };

    var Product = function () {
        var self = this;
        // string Example: '038e1c2de69f4b34'
        self.sku = null;
        // string Example: 'EN'
        self.languageId = 'EN';
        // string Example: 'Lee Cooper'
        self.vendorName = null;
        // string Example: '038e1c2de69f4b34'
        self.externalProductId = null;
        // string Example: '042100005264'
        self.upc = null;
        // string Example: '042100005264'
        self.productCode = 0;
        // array Example: [{ languageId: 'EN', name: 'Jack Daniels' }]
        self.namesLocalized = [{ languageId: self.languageId }];
        // string Example: '2'
        self.categoryId = null;
        // string Example: 'TestCategory'
        self.categoryName = null;
        // double Example: 33207.00
        self.unitPrice = null;
        // double Example: 33207.00
        self.cost = null;
        // bit Example: 0 - False, 1 - True
        self.isTaxable = null;
        // array Example: [ {"taxId":"10", "taxName":"Sale Tax", "taxRate": "7.00"}]
        self.taxList = [];
        // int Example: 0
        self.sortOrder = 0;
        // bit Example: 0 - False, 1 - True
        self.isDiscountable = false;
        // ProductType Example: productSDK.ProductType.Regular
        self.productType = null;
        // InventoryType Example: productSDK.InventoryType.Standard
        self.inventoryType = null;
        // double Example: 0
        self.minPrice = 0;
        // bit Example: 0 - False, 1 - True
        self.isReturnable = null;
        // bit Example: 0 - False, 1 - True
        self.isVoidable = null;
        // string Example: '1231231'
        self.systemCategoryId = null;
        // string Example: '1414142412'
        self.manufactureId = null;
        // string Example: '14321536563234432532'
        self.vendorExternalId = null;
        // bit Example: 0 - False, 1 - True
        self.isActive = null;

        this.__defineSetter__("name", function (val) {
            self.namesLocalized[0].name = val;
        });
        this.__defineGetter__("name", function () {
            return self.namesLocalized[0].name;
        });
        this.__defineSetter__("description", function (val) {
            self.namesLocalized[0].description = val;
        });
        this.__defineGetter__("description", function () {
            return self.namesLocalized[0].description;
        });
        this.__defineSetter__("shortName", function (val) {
            self.namesLocalized[0].shortName = val;
        });
        this.__defineGetter__("shortName", function () {
            return self.namesLocalized[0].shortName;
        });
    };

    var Customer = function () {
        var self = this;
        // string Example: 'John'
        self.firstName = null;
        // string Example: 'Doe'
        self.lastName = null;
        // string Example: 'B'
        self.middleNames = null;
        // string Example: date
        self.birthDate = null;
        // string Example: 102938475
        self.dandBNumber = null;
        // CustomerAddress
        self.address = {};
        // int Example: marketing: true - 1, false - 0
        self.marketing = null;
        // int Example: customerType: Personal = 0, Business = 1
        self.customerType = null;
        // string Example: 'jnjk4j423j4l2j424b2o4j'
        self.driverLicenseNumber = null;
        // string Example: 'NY'
        self.driverLicenseState = null;
        // string Example: 'Ikea'
        self.companyName = null;
        // string Example: 'Viktor'
        self.contactFirstName = null;
        // string Example: 'Balykhin'
        self.contactLastName = null;
        // string Example: 'PE'
        self.contactMiddleName = null;
        // string Example: '0123456' (max 10 length)
        self.taxId = null;
        // int Example: isTaxExempt: true - 1, false - 0
        self.isTaxExempt = null;
        // string Example: 'notes'
        self.notes = null;
        // int Example: acceptChecksCode: Default = 0, AcceptChecks = 1, DoNotAcceptChecks = 2
        self.acceptChecksCode = null;
        // int Example: 1000000
        self.creditLimit = null;
        // int Example: 1
        self.homeStore = null;
        // string Example: 'test'
        self.salesRep = null;
        //string Example: '678665bngj67nb'
        self.referenceNumber = null;
        // int Example: 0 - False, 1 - True
        self.isCustomerReadOnly = null;
        // int Example: 0 - False, 1 - True
        self.performLookup = null;
        // int Example: 0 - False, 1 - True
        self.getFoundCustomers = null;
        // int Example: 0 - False, 1 - True
        self.restrictUpdateOnCreation = null;
    };

    var CustomerAddress = function () {
        var self = this;

        // string Example: 'New York'
        self.city = null;
        // string Example: '29 eHopper Street'
        self.addressLine1 = null;
        self.addressLine2 = null;
        // string Example: 'NY'
        self.territory = null;
        // string Example: '10008'
        self.postalCode = null;
        // string Example: '9323' USE ONLY TO THE '0.0.12' SDK VERSION
        self.postalCodeExtension = null;
        // string Example: 'US' USE ONLY TO THE '0.0.12' SDK VERSION
        self.isoCountryId = null;
        // string Example: '+12314762343'
        self.phone = null;
        // string Example: '+12314762343'
        self.mobilePhone = null;
        // string Example: 'johndoe@doe.org'
        self.eMail = null;
        // string Example: 'http://ehopper.com'
        self.website = null;
    };

    var ClearCartRequest = function () {
        var self = this;
        //string Example: Y/N
        self.isClearAllProducts = null;
        //string Example: 05f5e291-f1f7-1077-1136-000800004df7, 05f5e291-f1f7-1077-1136-000800004df7
        self.lineItemList = new Array();
        //string Example: Y/N
        self.isClearCustomer = null;

        this.__defineSetter__("lineItemIdList", function (val) {
            self.lineItemList = new Array();

            if (val) {
                val.split(',').forEach(function (item) {
                    self.lineItemList.push({ lineItemId: item.trim() });
                });
            }
        });

        this.__defineGetter__("lineItemIdList", function () {
            if (!self.lineItemList) {
                return null;
            }

            var lineItemIds = self.lineItemList.map(function (item) {
                return item['lineItemId'];
            });

            return lineItemIds.join(',');
        });
    };

    var ReturnLineItem = function () {
        var self = this;

        //int Example: 1001
        self.lineItemId = null;

        //string Example: 
        self.returnReasonCodeId = null;

        //string Example: 0 - False, 1 - True
        self.isReasonCodeReadonly = 0;

        //int Example: 1002
        self.cartBundleId = null;

        //string Example: "TESTAPPIFRAME"
        self.appId = null;

        //int Example: 10
        self.quantity = null;

        //string Example: 0 - False, 1 - True
        self.isQuantityReadonly = 1;

        //string Example: 0 - False, 1 - True
        self.isTaxReadonly = 0;

        // array Example: [ Tax obj]
        self.taxList = [];

        // double Example: 33207.00
        self.unitPrice = null;

        // string Example: 2
        self.gradeCodeId = null;

        //string Example: 0 - False, 1 - True
        self.includeCoupons = 1;

        //string Example: 0 - False, 1 - True
        self.includeDiscounts = 1;

        //string Example: 0 - False, 1 - True
        self.includeTax = 1;

        //string Example: "new product description"
        self.description = null;

        //string externalServiceInfo: null
        self.externalServiceInfo = null;

        // string Example: null
        self.activationInfo = null;

        //string Example: 0 - False, 1 - True
        self.isHiddenOnReceipt = 0;

        // array Example: [{itemName:"Customer Name", itemValue: "John Doe", order: 0}]
        self.receiptData = null;

        //string Example: 0 - False, 1 - True
        self.isAllowActivationExchange = 0;
    };

    var Tax = function () {
        var self = this;

        //int Example: 1001
        self.taxCode = 10;

        //string Example: "Sale Tax"
        self.taxShortName = null;

        //double Example: 207.00
        self.taxAmount = 0;

        //double Example: 7.00
        self.taxRate = 0;
    };

    var ReturnTransactionRequest = function () {
        var self = this;

        //int Example: 100
        self.transactionId = null;

        //int Example: [ReturnLineItem obj]
        self.lineItemList = new Array();

        this.__defineSetter__("returnLineItems", function (val) {
            self.lineItemList = new Array();

            if (val) {
                var jsonObj = null;

                if (typeof (val) === "string") {
                    jsonObj = JSON.parse(val);
                } else if (typeof (val) === "object") {
                    jsonObj = val;
                }

                if (jsonObj && jsonObj.hasOwnProperty("length")) {
                    self.lineItemList = jsonObj;
                } else if (jsonObj && jsonObj.hasOwnProperty("lineItemId") && jsonObj.lineItemId) {
                    self.lineItemList.push(jsonObj);
                }
            }
        });

        this.__defineGetter__("returnLineItems", function () {
            if (!self.lineItemList) {
                return null;
            }

            return JSON.stringify(self.lineItemList);
        });
    };

    var SendSubcriptionCancelationRequest = function () {
        var self = this;

        //string Example: success, failed
        self.result = null;
    };

    var LineItem = function () {
        var self = this;

        //int Example: 1001
        self.id = null;

        // string Example: null
        self.externalServiceInfo = null;

        //object Example: instance of PhoneExchange
        self.phoneExchange = null;

        //object Example: instance of SimExchange
        self.simExchange = null;

        // string Example: "ACTIVATED"
        self.status = null;

        // string Example: "Details"
        self.statusDetails = null;

        // array Example: [{itemName:"Customer Name", itemValue: "John Doe", order: 0}]
        self.receiptData = null;
    };

    var PhoneExchange = function () {
        var self = this;

        //string Example: "34234234"
        self.esn = null;

        //bool Example: true/false
        self.isCustomerPhone = false;

        // string Example: "any notes"
        self.notes = null;

        //string Example: "IPhone X 256Gb"
        self.phoneModel = null;
    };

    var SimExchange = function () {
        var self = this;

        //string Example: "3423423"
        self.sim = null;

        //bool Example: true/false
        self.isCustomerSim = false;

        //string Example: "any notes"
        self.notes = null;
    };

    var UpdateTransactionRequest = function () {
        var self = this;

        //int Example: 100
        self.transactionId = null;

        //string Example: Test Notes
        self.notes = null;

        //array Example: [LineItem obj]
        self.lineItemList = new Array();

        this.__defineSetter__("lineItems", function (val) {
            self.lineItemList = new Array();

            if (val) {
                var jsonObj = null;

                if (typeof (val) === "string") {
                    jsonObj = JSON.parse(val);
                } else if (typeof (val) === "object") {
                    jsonObj = val;
                }

                if (jsonObj && jsonObj.hasOwnProperty("length")) {
                    self.lineItemList = jsonObj;
                } else if (jsonObj && jsonObj.hasOwnProperty("id") && jsonObj.id) {
                    self.lineItemList.push(jsonObj);
                }
            }
        });

        this.__defineGetter__("lineItems", function () {
            if (!self.lineItemList) {
                return null;
            }

            return JSON.stringify(self.lineItemList);
        });
    };

    var FrameOptions = function () {
        var self = this;

        //string Example: 0 - False, 1 - True
        self.fullScreenMode = null;

        //int Example: 3000 or 0 - to remove timeout
        self.timeout = null;

        //int Example: 1250. 0/null - reset to default
        self.width = null;

        //int Example: 900. 0/null - reset to default
        self.height = null;

        //string Example: 0 - False, 1 - True
        self.hideDefaultHeader = null;

        //string Example: Test App Iframe 
        self.headerTitle = null;

        //string Example: default | small
        self.headerSize = null;
    };

    // Send postmessage for get current customer and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var getCurrentCustomer = function (funcPostTimout) {
        return sendRequest('GetCurrentCustomer', null, funcPostTimout);
    };

    // Send postmessage for get confirmation info and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var getConfirmationInfo = function (confirmationInfo, funcPostTimout) {
        return sendRequest('GetConfirmationInfo', confirmationInfo, funcPostTimout);
    };

    // Send postmessage for send confirmation result info and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var confirmationResult = function (confirmationResultInfo, funcPostTimout) {
        return sendRequest('ConfirmationResultInfo', confirmationResultInfo, funcPostTimout);
    };

    // Send postmessage for send cancel result info and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var cancelResult = function (cancelResultInfo, funcPostTimout) {
        return sendRequest('CancelResultInfo', cancelResultInfo, funcPostTimout);
    };

    // Send postmessage for get cancel info and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var getCancelInfo = function (cancelInfo, funcPostTimout) {
        return sendRequest('GetCancelInfo', cancelInfo, funcPostTimout);
    };

    // Send postmessage for get new access_token and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var requestToNewToken = function (funcPostTimout) {
        return sendRequest('RequestToNewToken', null, funcPostTimout);
    };

    // Send postmessage for set customer and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var setCustomer = function (customer, funcPostTimout) {
        return sendRequest('SetCustomer', customer, funcPostTimout);
    };

    // Send postmessage for add products to cart and wait for the response
    // You can add to cart only existing product
    // Exist check on externalProductId or UPC AND SKU AND SERIAL
    // If response not send from eHopper we are run method funcPostTimout
    var addProductLineItemsToCart = function (productLineItems, funcPostTimout) {
        return sendRequest('AddProductLineItemsToCart', productLineItems, funcPostTimout);
    };

    // Send postmessage for update products to cart and wait for the response
    // You can update item in cart only by productLineItemId
    // productLineItemId return in response object like field Id from call method getProductLineItemsFromCart
    // If response not send from eHopper we are run method funcPostTimout
    var updateProductLineItemsInCart = function (productLineItems, funcPostTimout) {
        return sendRequest('UpdateProductLineItemsToCart', productLineItems, funcPostTimout);
    };

    // Send postmessage for create product and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var createProduct = function (productToCreate, funcPostTimout) {
        return sendRequest('CreateProduct', productToCreate, funcPostTimout);
    };

    // Send postmessage for open Url to external browser and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var openUrlToExternalBrowser = function (url, funcPostTimout) {
        return sendRequest('OpenUrlToExternalBrowser', url, funcPostTimout);
    };

    // Send postmessage for find products by Sku and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var findProductBySku = function (sku, funcPostTimout) {
        return sendRequest('FindProductBySku', sku, funcPostTimout);
    };

    // Send postmessage for find products by Upc and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var findProductByUpc = function (upc, funcPostTimout) {
        return sendRequest('FindProductByUpc', upc, funcPostTimout);
    };

    // Send postmessage for find products by Serial and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var findProductBySerial = function (serial, funcPostTimout) {
        return sendRequest('FindProductBySerial', serial, funcPostTimout);
    };

    // Send postmessage for close current App view and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var closeIFrame = function (funcPostTimout) {
        return sendRequest('CloseIFrame', null, funcPostTimout);
    };

    // Send postmessage for get products from cart and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var getProductLineItemsFromCart = function (funcPostTimout) {
        return sendRequest('GetProductLineItemsFromCart', null, funcPostTimout);
    };

    // Send postmessage for get version of SakesSdk listener and wait for the response
    // If response not send from eHopper we are run method funcPostTimout
    var getSalesSdkListenerVersion = function (funcPostTimout) {
        return sendRequest('GetSalesSdkListenerVersion', null, funcPostTimout);
    };

    var clearShoppingCart = function (clearRequest, funcPostTimout) {
        return sendRequest('ClearShoppingCart', clearRequest, funcPostTimout);
    };

    var signatureCapture = function (displayText, funcPostTimeout) {
        return sendRequest('SignatureCapture', displayText, funcPostTimeout);
    };

    var returnTransaction = function (returnLineItemsRequest, funcPostTimout) {
        return sendRequest('ReturnTransaction', returnLineItemsRequest, funcPostTimout);
    };

    var getCardToken = function (queryNewToken, funcPostTimeout) {
        return sendRequest('GetCardToken', queryNewToken, funcPostTimeout);
    };

    var updateTransaction = function (updateTransactionRequest, funcPostTimeout) {
        return sendRequest('UpdateTransaction', updateTransactionRequest, funcPostTimeout);
    };

    var getTransaction = function (transactionId, funcPostTimeout) {
        return sendRequest('GetTransaction', transactionId, funcPostTimeout);
    };

    var getStoreAccountInfo = function (storeAccountRequest, funcPostTimeout) {
        return sendRequest("GetStoreAccountInfo", storeAccountRequest, funcPostTimeout);
    };

    var setFrameOptions = function (setFrameOptionsRequest, funcPostTimeout) {
        return sendRequest("SetFrameOptions", setFrameOptionsRequest, funcPostTimeout);
    };

    var getEnvironmentInfo = function (funcPostTimeout) {
        return sendRequest("GetEnvironmentInfo", null, funcPostTimeout);
    };

    var getCancelSubscribersInfo = function (funcPostTimeout) {
        return sendRequest("GetCancelSubscribersInfo", null, funcPostTimeout);
    }

    var sendCancelSubscribersResult = function (cancelSubscriptionResult, funcPostTimeout) {
        return sendRequest('SendCancelSubscribersResult', cancelSubscriptionResult, funcPostTimeout);
    }

    var sendRefreshStatusResult = function (refreshStatusResult, funcPostTimeout) {
        return sendRequest('SendRefreshStatusResult', refreshStatusResult, funcPostTimeout);
    }

    function generatePostId() {
        var left = Math.random() * (Date.now() | 0);
        var right = '';
        var pos = 0;
        while (pos++ < 10) {
            right += String.fromCharCode(Math.random() * (122 - 33) + 33 | 0);
        }
        return left + right;
    }

    function noop() {

    }

    var sendRequest = function (eventName, eventData, timoutCallback) {
        addListenerToPostMessage(checkResponse);
        var postId = eventName + ':' + generatePostId();
        var promise = new Promise((resolve, reject) => {
            sendsMessageDic[postId] = { resolve, reject }
        });
        window.top.postMessage({ postId: postId, postData: eventData }, "*");//window.location.href

        timeoutObjs[postId] = setTimeout(timoutCallback || noop, timeout);
        return promise;
    };

    // listener of response from eHopper
    var checkResponse = function (event) {
        //if (event.origin != 'http://javascript.ru') {
        //    // check domain
        //    return;
        //}

        var awaiter = timeoutObjs[event.data.postId];
        if (awaiter) {
            clearTimeout(awaiter);

            if (event.data.response.isError) {
                sendsMessageDic[event.data.postId].reject(event.data.response);
            }
            else {
                sendsMessageDic[event.data.postId].resolve(event.data.response);
            }

            delete sendsMessageDic[event.data.postId];
            delete timeoutObjs[event.data.postId];
        }
    };

    // Add listener to eHopper
    var addListenerToPostMessage = function (func) {
        if (window.addEventListener) {
            window.addEventListener("message", func);
        } else {
            // IE8
            window.attachEvent("onmessage", func);
        }
    };

    return {
        getCancelInfo: getCancelInfo,
        cancelResult: cancelResult,
        addProductLineItemsToCart: addProductLineItemsToCart,
        getConfirmationInfo: getConfirmationInfo,
        confirmationResult: confirmationResult,
        createProduct: createProduct,
        product: Product,
        productLineItem: ProductLineItem,
        getProductLineItemsFromCart: getProductLineItemsFromCart,
        findProductBySku: findProductBySku,
        findProductBySerial: findProductBySerial,
        ProductType: ProductType,
        customer: Customer,
        customerAddress: CustomerAddress,
        InventoryType: InventoryType,
        closeIFrame: closeIFrame,
        findProductByUpc: findProductByUpc,
        getCurrentCustomer: getCurrentCustomer,
        setCustomer: setCustomer,
        openUrlToExternalBrowser: openUrlToExternalBrowser,
        getSalesSdkListenerVersion: getSalesSdkListenerVersion,
        salesSdkVersion: salesSdkVersion,
        updateProductLineItemsInCart: updateProductLineItemsInCart,
        requestToNewToken: requestToNewToken,
        clearShoppingCart: clearShoppingCart,
        clearCartRequest: ClearCartRequest,
        signatureCapture: signatureCapture,
        returnTransactionRequest: ReturnTransactionRequest,
        returnTransaction: returnTransaction,
        returnLineItem: ReturnLineItem,
        getCardToken: getCardToken,
        tax: Tax,
        updateTransactionRequest: UpdateTransactionRequest,
        getTransaction: getTransaction,
        lineItem: LineItem,
        updateTransaction: updateTransaction,
        phoneExchange: PhoneExchange,
        simExchange: SimExchange,
        getStoreAccountInfo: getStoreAccountInfo,
        setFrameOptions: setFrameOptions,
        frameOptions: FrameOptions,
        getEnvironmentInfo: getEnvironmentInfo,
        getCancelSubscribersInfo: getCancelSubscribersInfo,
        sendCancelSubscribersResult: sendCancelSubscribersResult,
        sendSubcriptionCancelationRequest: SendSubcriptionCancelationRequest,
        sendRefreshStatusResult: sendRefreshStatusResult
    };
};

// this is for node js
if (typeof module === "object" && typeof module.exports === "object") {
    module.exports['WebPosSalesSDK'] = SalesSDK;
}
